import { isEmpty } from 'lodash-es';
import Swal from 'sweetalert2';
import Address from "../entrypoints/src/admin/components/address";
import { Controller } from "stimulus";
import Cleave from 'cleave.js';

export default class extends Controller {
  connect() {
		this.$requiredElements = this.element.querySelectorAll('#name, #legal-name, #cnpj, #postal_code, #address, #neighborhood, #number, #phone, #city, #state');
		this.$saveButton = this.element.querySelector('button[type="submit"]');
		this.$cnpj = this.element.querySelector('#cnpj');
		let _self = this, cnpjCleave = null;

		Address.init({
      container: this.element,
      input: this.element.querySelector('.mask-postal-code'),
			actionButton: this.element.querySelector('.find-address'),
			onComplete: () => this.update()
    });
		this.$cnpj.addEventListener('focus', () => !!cnpjCleave && cnpjCleave.destroy());
		this.$cnpj.addEventListener('blur', () => {
			let value = _self.$cnpj.value.replaceAll(/[\D]/g, '');
			_self.$cnpj.value = value;

			let options = {
				numericOnly: true,
				blocks: [2, 3, 3, 4, 2],
				delimiters: [".", ".", "/", "-"]
			}

			if (value.length <= 11) {
				options.blocks = [3, 3, 3, 2]
      	options.delimiters = [".", ".", "-"]
			}

			cnpjCleave = new Cleave(_self.$cnpj, options);
		});
		this.$requiredElements.forEach(($el) => $el.addEventListener('blur', () => this.update()));
		this.$saveButton.addEventListener('click', (ev) => {
			if (this.$saveButton.classList.contains('disabled')) {
				ev.preventDefault();

				Swal.fire({
					title: 'Atenção',
					text: 'Preencha os campos destacados com asterisco corretamente para continuar'
				});
			}
		});

		this.update();
	}

	update() {
		let valid = [...this.$requiredElements].reduce((accumulator, current) => { return accumulator &= !isEmpty(current.value) }, true);
		this.$saveButton.classList.toggle('disabled', !valid);
	}
}
